import { Modal, Box, Input, Button } from "@mui/material";
import React, { useState } from "react";
import authService from "services/authService";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PropTypes from "prop-types";

function EmailModel({
  openEmailModel,
  closeEmailModel,
  userId,
  openAlertModel,
}) {
  const modules = {
    toolbar: [
      ["bold", "italic"],
      ["link"],
      // [{ header: [1, 2, 3, 4, 5] }],
      [{ list: "bullet" }],
    ],
  };
  const [emailState, setEmailState] = useState({
    ccEmail: "",
    bcEmail: "",
    mailBody: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setEmailState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeReactQuill = (event) => {
    const text1 = event.split("<p>")[1];
    const text2 = text1.split("</p>")[0];
    setEmailState((prev) => ({
      ...prev,
      mailBody: text2,
    }));
  };
  const sendEmail = () => {
    const { ccEmail, bcEmail, mailBody } = emailState;
    authService
      .sentEmailUser(userId, ccEmail, bcEmail, mailBody)
      .then(() => {
        openAlertModel(
          "elailAlertSuccess",
          "email sent successfuly",
          "success",
          "elailAlertSuccess"
        );
        closeEmailModel();
      })
      .catch(() => {
        openAlertModel(
          "emailAlertError",
          "something went Wrong !",
          "error",
          "emailAlertError"
        );
        closeEmailModel();
      });
  };

  return (
    <div className="b-SendEmail-container">
      <Modal
        className="b-SendEmail-container__modal"
        open={openEmailModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="b-SendEmail-container__box">
          <div className="b-SendEmail-container__parent">
            <div className="b-SendEmail-container__child">
              <text className="dafault-font-family-bold b-SendEmail-container__text">
                CC:
              </text>
              <Input
                className="dafault-font-family b-SendEmail-container__input"
                variant="standard"
                name="ccEmail"
                onChange={handleChange}
              />
              <text className="dafault-font-family-bold b-SendEmail-container__text-2">
                BCC:
              </text>
              <Input
                className="dafault-font-family b-SendEmail-container__input"
                variant="standard"
                name="bcEmail"
                onChange={handleChange}
              />
            </div>
            <div className="b-SendEmail-container__editor-text">
              <ReactQuill
                className="b-SendEmail-container__editor-qill"
                modules={modules}
                theme="snow"
                onChange={handleChangeReactQuill}
              />
            </div>
          </div>

          <div className="b-SendEmail-container__btn-section">
            <Button
              className="b-SendEmail-container__btn"
              onClick={sendEmail}
              variant="outlined"
            >
              Send
            </Button>
            <Button
              className="b-SendEmail-container__btn-cancel"
              variant="outlined"
              onClick={closeEmailModel}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
EmailModel.propTypes = {
  openEmailModel: PropTypes.func.isRequired,
  closeEmailModel: PropTypes.func.isRequired,
  userId: PropTypes.bool.isRequired,
  openAlertModel: PropTypes.func.isRequired,
};

export default EmailModel;
